import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <div className="max-w-xl mx-auto px-4 py-32 text-center">
      <Seo title="Not Found" />
      <h1 className="font-serif-display text-6xl mb-3">404</h1>
      <p className="text-muted-foreground mb-6">We couldn't find that page — but there's plenty of cosy makes to explore.</p>
      <Link to="/" className="inline-block bg-brand-ink text-white px-8 py-3 rounded-sm text-sm uppercase tracking-luxe hover:bg-brand-pink hover:text-brand-ink transition-colors">Back home</Link>
    </div>
  );
}
